module.exports = __webpack_public_path__ + "static/media/Wearpeachi_5_Studio Midline Bra in Stone.893f0bb9.jpeg";